import { render } from "./Recharge.vue?vue&type=template&id=1020657e&scoped=true"
import script from "./Recharge.vue?vue&type=script&lang=js"
export * from "./Recharge.vue?vue&type=script&lang=js"

import "./Recharge.vue?vue&type=style&index=0&id=1020657e&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1020657e"]])

export default __exports__